const Footer = () => {

    return (

        <footer>
            <p>Made by <a href="https://robpetrungaro.com" target='blank' rel="noreferrer">RP</a> at <a href="https://junocollege.com" target='_blank' rel="noreferrer">Juno College</a></p>
        </footer>
    )
}

export default Footer;